export enum BroadcastType {
  PROMO_CONTACT = 'promo-contact',
  PROGRAM_SPEAKER = 'program-speaker',
}
